export default {
  state: () => ({
    ressources: []
  }),
  getters: {
    ressources: (state) => {
      return state.ressources
    }
  },
  mutations: {
    SET_RESSOURCES(state, ressources) {
      state.ressources = ressources
    }
  }
}